export const getAdditionalObj = ad => {
  return ad && ad.appointment && ad.appointment.entity && ad.appointment.entity.additional;
};

export const getEntityObj = ad => {
  return ad && ad.appointment && ad.appointment.entity;
};

export const isVideoConsultation = (appointment) => {
  return (appointment && appointment.appointment && appointment.appointment.entity && appointment.appointment.entity.type === 'video_consultation')
}